export default function () {
  const namespace = "call-to-action";
  const items = document.querySelectorAll(`[id^="${namespace}"]`);

  if (!items) {
    return;
  }

  const createIntersectionObserver = (element, callback, options) => {
    let observer = new IntersectionObserver(callback, options);
    observer.observe(element);
    return observer;
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute("data-animation-play-state", "running");
        observer.unobserve(entry.target);
      }
    });
  };

  const options = {
    threshold: 0.25,
  };

  items.forEach((item) => {
    createIntersectionObserver(item, callback, options);
  });
}
